import React from 'react'

const DefaultEmptyMsg = ({msg, size = "40px"}) => {
  return (
    <div className="page-content m-auto">
    <div className="white-space d-flex justify-content-center">
      <div className="white-c">
        <div className="soon align-self-end"
          style={{
            fontSize: size,
          }}
        >{msg}</div>
      </div>
    </div>
  </div>
  )
}

export default DefaultEmptyMsg